import moment from 'moment'

export default class Declaracao {

    constructor(
        declarante={},
        itens=[],
        semBens=false,
        situacao='EM_BRANCO',
        dataDeclaracao=moment().format('YYYY-MM-DD'),
        numeroRetificacao=0,
        justificativa=null
      ) {
        this.declarante = declarante;
        this.itens = itens;
        this.semBens = semBens;
        this.situacao = situacao;
        this.dataDeclaracao = dataDeclaracao;
        this.numeroRetificacao = numeroRetificacao;
        this.justificativa = justificativa;
    }
}



// WEBPACK FOOTER //
// ./src/domain/declaracao/index.js